import type { GetDocumentAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import { GetDocumentAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import type { AuditLogQueryResult } from './auditLogQueryResult';

type UseGetDocumentAuditByIdArgs = {
  id: string;
};

export const useGetDocumentAuditById = createQueryHook<
  UseGetDocumentAuditByIdArgs,
  GetDocumentAuditByIdResponseRow[],
  AuditLogQueryResult<'document_audit', GetDocumentAuditByIdResponseRow>
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getDocumentAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ document_audit: data }),
  graphqlDocument: GetDocumentAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
